/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents different flow types
 * EXTERNAL - Represents CarrierLogistics flow
 * INTERNAL - Represents Passport flow
 * <\/code><\/pre>
 **/
export var FlowType;
(function (FlowType) {
    FlowType["INTERNAL"] = "INTERNAL";
    FlowType["EXTERNAL"] = "EXTERNAL";
})(FlowType || (FlowType = {}));
